__webpack_require__.p = "https://inx-stg-310094-micro-fe-dhl-logistics.inxide.it//";